module.exports = __webpack_public_path__ + "static/media/road_webp.825bfa3b.gif";